export default {
    watch: {
        '$store.state.language': function() {
            this.$store.commit('SetPage', 1)
            this.getProducts()
        },
        '$store.state.isAuth': function() {
            this.getProducts()
        },
    },// watch
}